<!-- @format -->

<div class="small-sidenav" id="size-chart-wrapper">
	<button
		hmf-action-text
		variant="secondary"
		class="size-chart-link"
		(click)="getSizeChart()">
		Size Chart
	</button>
</div>

<ng-template #sizeChartContent>
	<div
		id="pdp-size-chart"
		class="sizechart-sidenav hmf-p-s hmf-p-md-m"
	>
		@if (isAem) {
			<div [innerHTML]="displayHtml"></div>
		} @else {
			<ng-container #LazySizeChartKraken></ng-container>
		}
		@if (loading) {
			<div class="title-skeleton-container">
				<hmf-skeleton
					class="hmf-display-block hmf-mb-xs"
					width="100%"
					height="25px"
					borderRadius="0"
					[loading]="true"></hmf-skeleton>
			</div>
			<div class="subtitle-skeleton-container">
				<hmf-skeleton
					class="hmf-display-block hmf-mb-m"
					width="100%"
					height="14px"
					borderRadius="0"
					[loading]="true"></hmf-skeleton>
			</div>
			<div class="caption-skeleton-container">
				<hmf-skeleton
					class="hmf-display-block hmf-mb-xs"
					width="100%"
					height="14px"
					borderRadius="0"
					[loading]="true"></hmf-skeleton>
			</div>
			<hmf-skeleton
				class="hmf-display-block hmf-mb-l"
				width="100%"
				height="400px"
				borderRadius="8px"
				[loading]="true"></hmf-skeleton>
			<div class="caption-skeleton-container">
				<hmf-skeleton
					class="hmf-display-block hmf-mb-xs"
					width="100%"
					height="14px"
					borderRadius="0"
					[loading]="true"></hmf-skeleton>
			</div>
			<hmf-skeleton
				class="hmf-display-block hmf-mb-l"
				width="100%"
				height="400px"
				borderRadius="8px"
				[loading]="true"></hmf-skeleton>
		}
		@if (sizeChartSurveyId !== '') {
			<div
				class="hmf-mt-l-l hmf-pb-l">
				<pdp-feedback [formId]="sizeChartSurveyId"> </pdp-feedback>
			</div>
		}
	</div>
</ng-template>
